import React, { useEffect, memo } from "react";
import { useTranslation } from "react-i18next";
import { Button, Menu } from "antd";
import { useHistory } from "react-router-dom";

import "./menu.scss";

import { GET_FEATURE_MENU } from "constants/permission";
import { useSelector } from "react-redux";


function MenuComponent(props) {
  const { t: translation } = useTranslation();
  const history = useHistory();
  const { pathName } = props;
  const setting = useSelector((state) => state.setting);
  const FEATURE = GET_FEATURE_MENU(translation, setting)

  const _onClick = (href) => {
    history.push(href);
  };
  const gitbook = () => {
    window.location =
      "https://ttdk-organization.gitbook.io/huong-dan-quan-ly-trung-tam/";
  };

  return (
    <div className="menu-container-mobie">
      <div className="header-container">
        <Menu
          mode="horizontal"
          defaultSelectedKeys={pathName}
        >
          <div>
            <div className="d-flex w-100 justify-content-center menu-container">
              {
                FEATURE.map((item) => (
                  <Menu.Item
                    className={`menu-item ${
                      (item && item.href && pathName === item.href) ||
                      item.routerChildren.includes(pathName)
                        ? "active"
                        : ""
                    }`}
                    onClick={
                      item.href === "/question"
                        ? gitbook
                        : () => {
                            if (!item.isNoHref) {
                              _onClick(item.href);
                            }
                          }
                    }
                    key={Math.random()}
                  >
                    <div>
                      {item?.icon || <></>}
                      {item.name.toUpperCase()}
                    </div>
                  </Menu.Item>
                ))
              }
            </div>
          </div>
        </Menu>
      </div>
    </div>
  );
}

export default memo(MenuComponent);
